import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { ROUTE } from '../constant/route.constant';
import { BizflexFacade } from '../store';
import { map, Observable } from 'rxjs';
import { PersonnelAppointment } from '@core/data-access';

@Injectable({ providedIn: 'root' })
export class CalculatorGuard implements CanActivate {
  private readonly bizflexFacade = inject(BizflexFacade);
  private readonly router = inject(Router);

  canActivate(): Observable<boolean | UrlTree> {
    return this.bizflexFacade.director$.pipe(
      map(director => {
        if (!director || !director.appointment.includes(PersonnelAppointment.KEYMAN)) {
          return this.router.createUrlTree([ROUTE.ERROR.MAIN, ROUTE.ERROR.FORBIDDEN]);
        }

        return true;
      }),
    );
  }
}
